<template>
	<div class="ui-text-field">
		<label v-if="label" :for="id">{{ label }}</label>
		<input v-if="type === 'number'" type="text" class="input is-primary" v-bind="$attrs"
			v-model.number="localValue" @input="handleInput" :id="id">
		<input v-else :type="type" class="input is-primary" v-bind="$attrs"
			v-model="localValue"
			@input="handleInput"
			:id="id"
			:placeholder="placeholder"
		>

		<div class="ui-text-field-validationError" v-if="validationError">{{ validationError }}</div>
	</div>
</template>

<script>
export default {
	inheritAttrs: false,

	props: ['value', 'rules', 'type', 'label', 'placeholder'],

	data: () => ({
		localValue: null,
		id: null,
		validationError: null
	}),

	watch: {
		value(to) {
			this.localValue = to;
		},

		localValue(to) {
			this.$emit('input', to);
		}
	},

	created() {
		this.localValue = this.value;
		this.id = new Date().getTime();
	},

	methods: {
		validateInput() {
			if (!this.rules) {
				return null;
			}

			const values = this.rules.map(fn => fn(this.localValue));

			this.validationError = values.some(val => val !== true) && values[0];

			return Boolean(this.validationError);
		},

		handleInput(event) {
			this.localValue = event.target.value;
			this.validateInput();
		}
	}
};
</script>

<style lang="scss">
.ui-text-field {
	.input {
		border-radius: 4px !important;
	}

	label {
		cursor: pointer;
	}
}

.ui-text-field-validationError {
	display: inline-block;
	font-size: 12px;
	color: hsl(348, 100%, 61%)
}
</style>
